/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { push } from 'redux-first-history';

import { StatusOperations } from 'const';
import { MODAL_OPEN } from 'redux/slices/modals';
import { SelectionPanel } from 'ui/components';

import PeopleModal from 'ui/components/Modals/PeopleModal';

import { Spinner } from '..';
import PlaceholderTableData from '../PlaceholderTableData';
import { Body } from './body';
import { Header } from './header';
import Pagination from './Pagination';
import { TableContainer } from './style';
import LeadsStatusModal from '../../components/Modals/LeadsStatusModal';

const Table = ({
  headerColumns,
  data,
  selection,
  pagination,
  onDelete,
  onPageChangeFetch,
  onToggle,
  detailhover,
  isChargerList,
  onResendEmail,
  onUpdateAccountStatus,
  onChangeUserRole,
  onSortByColumn,
  isRowExpandable,
  onExpandRow,
  expandedRowData,
  rowDivider,
  variant,
  onIconClick,
  corporate,
  totalPages,
  totalRecords,
  pageNo,
  isRFIDList,
  isPeopleList,
  pushUrl,
  isLoading,
  sortingInfo,
  onClick,
  itemPropForSelection,
  openPeopleModal,
  selectedHoverRow,
  size,
  customPlaceholder,
  onDownloadFile,
  pageSize,
  showMore,
  onStatusClick,
  isLeadsList,
  updateLeadsStatus,
  resetSelection,
  role
}) => {
  const [hovered, setHovered] = useState();
  const [checked, setChecked] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);

  const [columnWidths, setColumnWidths] = useState('');

  const [selectingItem, setSelectingItem] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  useEffect(() => {
    if (resetSelection) {
      removeAll();
    }
  }, [resetSelection]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const addSelection = (rowData, index) => {
    const indexSelection = [...checked];
    const rowsSelection = [...selectedRows];
    if (indexSelection.includes(index)) {
      const newSelection = indexSelection.filter(value => value !== index);
      const newRowSelection = rowsSelection.filter(
        row => row[itemPropForSelection] !== rowData[itemPropForSelection]
      );
      setChecked(newSelection);
      setSelectedRows(newRowSelection);
    } else if (detailhover) {
      setChecked([]);
    } else {
      indexSelection.push(index);
      rowsSelection.push(rowData);
      setSelectedRows(rowsSelection);
      setChecked(indexSelection);
    }
  };

  const removeAll = () => {
    setChecked([]);
    setSelectedRows([]);
  };

  const selectAll = () => {
    data.forEach((row, index) => {
      if (!checked.includes(index)) {
        setSelectedRows(prevState => [...prevState, row]);
        setChecked(prevState => [...prevState, index]);
      }
    });
  };

  const onToggleRow = rowData => {
    onToggle(rowData);
    removeAll();
  };

  const onPageChange = (page, pageSize) => {
    removeAll();
    onPageChangeFetch(page - 1, pageSize);
  };

  const onDeleteHoveredAccount = email => {
    onDelete([email]);
    removeAll();
  };

  const onModalAccept = (type, email) => {
    const cognitoId = email?.replace('@', '-');

    if (type === StatusOperations.DELETE) {
      onDeleteHoveredAccount(cognitoId);
    }

    if (type === StatusOperations.RESEND_EMAIL) {
      onResendEmail(cognitoId);
    }
  };

  const onDeleteRow = (e, rowData) => {
    e.stopPropagation();
    e.preventDefault();

    openPeopleModal({
      modalType: StatusOperations.DELETE,
      count: 1,
      onAccept: onModalAccept,
      email: rowData?.email,
      cognitoId: rowData?.cognitoId
    });
  };

  const onResendEmailAction = (e, emailData) => {
    e.stopPropagation();
    e.preventDefault();

    openPeopleModal({
      modalType: StatusOperations.RESEND_EMAIL,
      count: 1,
      onAccept: () =>
        onModalAccept(StatusOperations.RESEND_EMAIL, emailData.cognitoId),
      email: emailData?.email
    });
  };

  const onSort = columnName => {
    if (typeof onSortByColumn === 'function') {
      onSortByColumn(columnName);
      removeAll();
    }
  };

  useEffect(() => {
    setColumnWidths(
      headerColumns
        .map(column => (column.width ? column.width : '1fr'))
        .join(' ')
    );
  }, [headerColumns]);

  useEffect(() => {
    if (selectingItem) {
      addSelection(selectedRow.rowData, selectedRow.index);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectingItem, selectedRow, selectedRow.rowData, selectedRow.index]);

  return (
    <>
      <TableContainer variant={variant}>
        <Header
          columnWidths={columnWidths}
          headerColumns={headerColumns}
          onSort={onSort}
          sortingInfo={sortingInfo}
        />
        {isLoading ? (
          <Spinner />
        ) : data?.length ? (
          <Body
            columnWidths={columnWidths}
            data={data}
            selection={selection}
            headerColumns={headerColumns}
            hovered={hovered}
            setHovered={setHovered}
            addSelection={(rowData, index) => {
              if (corporate) {
                setSelectedRow({ rowData, index });
                setSelectingItem(true);
              } else {
                addSelection(rowData, index);
              }
            }}
            checked={checked}
            onToggleRow={onToggleRow}
            onDeleteRow={onDeleteRow}
            detailhover={detailhover}
            onResendEmailAction={onResendEmailAction}
            isRowExpandable={isRowExpandable}
            onExpandRow={onExpandRow}
            expandedRowData={expandedRowData}
            rowDivider={rowDivider}
            onIconClick={onIconClick}
            variant={variant}
            corporate={corporate}
            pushUrl={pushUrl}
            onClick={onClick}
            selectedHoverRow={selectedHoverRow}
            size={size}
            onDownloadFile={onDownloadFile}
            onPeople={isPeopleList}
            isLeadsList={isLeadsList}
            selectedStatus={
              selectedRows.length > 0 ? selectedRows?.[0]?.status : null
            }
            onStatusClick={onStatusClick}
            role={role}
          />
        ) : (
          <PlaceholderTableData customText={customPlaceholder} />
        )}
      </TableContainer>
      {!isLoading && data?.length && totalRecords > 10 && pagination ? (
        <Pagination
          onPageChange={onPageChange}
          totalPages={totalPages}
          totalRecords={totalRecords}
          pageNo={pageNo}
          pageSize={pageSize}
          showMore={showMore}
        />
      ) : (
        ''
      )}
      {checked.length > 0 ? (
        <SelectionPanel
          selectAll={selectAll}
          removeAll={removeAll}
          selectedRows={selectedRows}
          updateAccountStatus={onUpdateAccountStatus}
          deleteAccount={onDelete}
          changeUserRole={onChangeUserRole}
          isChargerList={isChargerList}
          isRFIDList={isRFIDList}
          isPeopleList={isPeopleList}
          isLeadsList={isLeadsList}
          updateLeadsStatus={updateLeadsStatus}
        />
      ) : (
        ''
      )}
      {isPeopleList && <PeopleModal />}
      {isLeadsList && <LeadsStatusModal />}
    </>
  );
};

Table.propTypes = {
  headerColumns: PropTypes.array,
  data: PropTypes.array,
  onToggle: PropTypes.func,
  selection: PropTypes.bool,
  onDelete: PropTypes.func,
  pagination: PropTypes.bool,
  onPageChangeFetch: PropTypes.func,
  detailhover: PropTypes.bool,
  isChargerList: PropTypes.bool,
  onResendEmail: PropTypes.func,
  onUpdateAccountStatus: PropTypes.func,
  onChangeUserRole: PropTypes.func,
  onSortByColumn: PropTypes.func,
  isRowExpandable: PropTypes.bool,
  onExpandRow: PropTypes.func,
  expandedRowData: PropTypes.object,
  rowDivider: PropTypes.bool,
  variant: PropTypes.string,
  onIconClick: PropTypes.func,
  pushUrl: PropTypes.func,
  corporate: PropTypes.bool,
  totalPages: PropTypes.number,
  totalRecords: PropTypes.number,
  pageNo: PropTypes.number,
  isRFIDList: PropTypes.bool,
  isPeopleList: PropTypes.bool,
  isLoading: PropTypes.bool,
  sortingInfo: PropTypes.object,
  onClick: PropTypes.func,
  itemPropForSelection: PropTypes.string,
  openPeopleModal: PropTypes.func,
  selectedHoverRow: PropTypes.func,
  size: PropTypes.number,
  customPlaceholder: PropTypes.string,
  onDownloadFile: PropTypes.func,
  pageSize: PropTypes.number,
  showMore: PropTypes.bool,
  onStatusClick: PropTypes.func,
  isLeadsList: PropTypes.bool,
  updateLeadsStatus: PropTypes.func,
  role: PropTypes.string
};

export default connect(
  () => ({}),
  dispatch => ({
    pushUrl: url => dispatch(push(url)),
    openPeopleModal: payload =>
      dispatch(MODAL_OPEN({ id: 'PeopleModal', payload }))
  })
)(Table);
